import { render, staticRenderFns } from "./Expendpolicy_a.vue?vue&type=template&id=4970765d&"
import script from "./Expendpolicy_a.vue?vue&type=script&lang=js&"
export * from "./Expendpolicy_a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports